import React from 'react';

import Sidebar from "./Sidebar/Sidebar"
import Bottombar from "./Sidebar/Bottombar"
import useScreenOrientation from './helpers/useScreenOrientation';
import Scene3D from "./Scene3D"
import ImageGallery from "./ImageGallery"
import SoloViewBullet from "./SoloViewBullet"
import LoadingScreen from "./LoadingScreen"
import AnimationInfo from "./AnimationInfo"
import { ProductData } from "../data/product.data"
import { ColorData } from "../data/color.data"

export default function SceneConfig({scenario, setScenario, setBlurBackground}: any) {

  const isLandscape = useScreenOrientation();

  const [roofProduct, setRoofProduct] = React.useState<any | null>(null);
  const [roofColor, setRoofColor] = React.useState<any | null>(null);
  const [facadeProduct, setFacadeProduct] = React.useState<any | null>(null);
  const [facadeColor, setFacadeColor] = React.useState<any | null>(null);
  const [productCategory, setProductCategory] = React.useState("roof");
  const [showActiveBullet, setShowActiveBullet] = React.useState<any | null>(null);
  
  const [isSidebarVisible, setIsSidebarVisible] = React.useState(true);
  const [showImageGallery, setShowImageGallery] = React.useState(false);
  const [showSoloViewBullet, setShowSoloViewBullet] = React.useState(false);
  const [bulletSelected, setBulletSelected] = React.useState<any>(null);
  const [showLoadingScreen, setShowLoadingScreen] = React.useState(true);
  const [showProductAnimation, setShowProductAnimation] = React.useState(false);

  const [menuView, setMenuView] = React.useState("PERSONALIZA");//"VISTA 3D" es vista en solitario

  React.useEffect(() => { //fix when switching scenarios.
    setProductCategory("roof")
  }, [scenario]);

  React.useEffect(() => {
    setBlurBackground(false)//despues de la pantalla de carga
    if(roofProduct === null){//si no se ha inicializado el producto, ponga el primero del escenario para fachada y cubierta
      setFacadeProduct(GetFirstAvailableProduct(scenario, "facade"))
      setRoofProduct(GetFirstAvailableProduct(scenario, "roof"))
    }else{
      if(!scenario.productsRoof.includes(roofProduct.id)){
        setRoofProduct(GetFirstAvailableProduct(scenario, "roof"))
      }
      if(roofColor === null || ProductContainsColor(roofProduct, roofColor) === false){
        setRoofColor(GetFirstAvailableColor(roofProduct));
      }

      if(facadeProduct !== null){
        if(!scenario.productsFacade.includes(facadeProduct.id)){
          setFacadeProduct(GetFirstAvailableProduct(scenario, "facade"))
        }  
        if(facadeColor === null || ProductContainsColor(facadeProduct, facadeColor) === false){
          setFacadeColor(GetFirstAvailableColor(facadeProduct));
        }
      }else{
        setFacadeProduct(GetFirstAvailableProduct(scenario, "facade"))
      }

    }
  }, [roofProduct, roofColor, facadeProduct, facadeColor, scenario, setBlurBackground]);

  const GetFirstAvailableProduct = (scenario : any, category : string) => {
    var firstProduct: any = null
    var productData: any = ProductData()
    var products = category === "roof" ? scenario.productsRoof : scenario.productsFacade
    for (let productID of products) {
      for (let product of productData) {
        if (product.active === true && product.id === productID){
          firstProduct = product
          break
        }
      }
      if(firstProduct !== null)
        break
    }
    return firstProduct;
  }
  const ProductContainsColor = (product : any, color : any) => {
    var colorData: any = ColorData()
    var containsColor = false;
    for (let colorProd of colorData[product.id]) {
      if(color.id === colorProd.id){
        containsColor = true;
        break;
      }
    }
    return containsColor;
  }

  const GetFirstAvailableColor = (product : any) => {
    var colorData: any = ColorData()
    return colorData[product.id][0];
  }

/*
  const GetFirstAvailableScenario = (product : any) => {
    var firstScenario: any = null
    var scenarioData: any = ScenarioData()
    for (let scenario of scenarioData) {
      if (scenario.active && scenario.products.includes(product.id)){
        firstScenario = scenario
        break
      }
    }
    return firstScenario;
  }*/

  const setLocalMenuView = (value : string) => {
    setShowImageGallery(value === "GALERÍA")
    setShowSoloViewBullet(value === "VISTA 3D")
    setMenuView(value)
  }

  const setLocalShowActiveBullet = (value : string) => {
    console.log("bullet selected: " + value)
    setShowActiveBullet(value)
    setTimeout(() => { setShowActiveBullet(null) }, 500);
  }
  

  return (
    <div className={`sceneconfig-scroller-container transition-fade-in`}>
      <Scene3D menuView={menuView} isLandscape={isLandscape} roofProduct={roofProduct} roofColor={roofColor} facadeProduct={facadeProduct} facadeColor={facadeColor} productCategory={productCategory} scenario={scenario} setScenario={setScenario} showSoloViewBullet={showSoloViewBullet} showProductAnimation={showProductAnimation} bulletSelected={bulletSelected} setShowLoadingScreen={setShowLoadingScreen} setShowProductAnimation={setShowProductAnimation} setShowActiveBullet={setLocalShowActiveBullet} />
      
      <SoloViewBullet isVisible={showSoloViewBullet} isSidebarVisible={isSidebarVisible} showActiveBullet={showActiveBullet} bulletSelected={bulletSelected} setBulletSelected={setBulletSelected}/>
      <ImageGallery isVisible={showImageGallery} isSidebarVisible={isSidebarVisible} product={productCategory === "roof" ? roofProduct : facadeProduct} color={productCategory === "roof" ? roofColor : facadeColor} setShowImageGallery={setShowImageGallery} setMenuView={setLocalMenuView}/>

      {isLandscape ?
        <Sidebar  roofProduct={roofProduct} roofColor={roofColor} setRoofProduct={setRoofProduct} setRoofColor={setRoofColor}
                  facadeProduct={facadeProduct} facadeColor={facadeColor} setFacadeProduct={setFacadeProduct} setFacadeColor={setFacadeColor}
                  productCategory={productCategory} setProductCategory={setProductCategory} scenario={scenario} setScenario={setScenario}
                  isSidebarVisible={isSidebarVisible} setIsSidebarVisible={setIsSidebarVisible} showImageGallery={showImageGallery} setShowImageGallery={setShowImageGallery} menuView={menuView} setMenuView={setLocalMenuView}/>
        :
        <Bottombar  roofProduct={roofProduct} roofColor={roofColor} setRoofProduct={setRoofProduct} setRoofColor={setRoofColor}
                    facadeProduct={facadeProduct} facadeColor={facadeColor} setFacadeProduct={setFacadeProduct} setFacadeColor={setFacadeColor}
                    productCategory={productCategory} setProductCategory={setProductCategory} scenario={scenario} setScenario={setScenario} 
                    isSidebarVisible={isSidebarVisible} setIsSidebarVisible={setIsSidebarVisible} showImageGallery={showImageGallery} setShowImageGallery={setShowImageGallery} menuView={menuView} setMenuView={setLocalMenuView} showActiveBullet={showActiveBullet}/>
      }

      {menuView === "VISTA 3D" && <AnimationInfo showProductAnimation={showProductAnimation} setShowProductAnimation={setShowProductAnimation}/>}
      
      <LoadingScreen isVisible={showLoadingScreen} isSidebarVisible={isSidebarVisible}/>
        
    </div>
  );
}
